<template>
  <div>
    <modal
      :ignoreBackdropClick="true"
      :show.sync="shown"
      headerClasses="justify-content-center"
      class="modal-options view-order-details-modal"
      v-if="order != null"
      modalClasses="modal-dialog-centered modal-dialog-scrollable"
    >
      <div slot="header" class="header-location-details">
        <h4 class="title title-up" :style="{ color: myTheme.modalTextColor }">
          {{ $t("text.ordered_menu") }}
        </h4>
        <div class="grid">
          <div class="location-logo">
            <el-image v-if="order.location" :src="order.location.logo">
              <div slot="error" class="image-slot">
                <img class="photo" src="img/logo-error-200.png" />
              </div>
            </el-image>
          </div>
          <div class="location-name">
            {{ order.location ? order.location.name : "-" }}
          </div>
          <div class="location-address">
            <i class="k-icon-location-1"></i>
            {{
              order.location && order.location.address
                ? generateFromatedAddress(order.location.address)
                : "-"
            }}
          </div>
        </div>
      </div>
      <cards class="previews-order-card">
        <div
          class="box items"
          v-html="orderItemsFormatter(order.orderItems, 'mb-2')"
        ></div>
      </cards>

      <template slot="footer">
        <n-button
          type="primary"
          :style="myTheme.customizeButton"
          round
          block
          @click.native="reOrder()"
          >{{ $t("button.order_again") }}
          <i v-if="isLoading" class="k-icon-spin4"></i>
        </n-button>
      </template>
    </modal>
    <re-order-confirmation
      v-if="order"
      ref="reOrderConfirmation"
      :itemsNotAvailable="itemsNotAvailable"
      :itemsWithDiffPrice="itemsWithDiffPrice"
      :itemsNotAvailableByType="itemsNotAvailableByType"
      :itemOptionsValuesAvailibility="itemOptionsValuesAvailibility"
      :itemsNotAvailableForToday="itemsNotAvailableForToday"
      :itemsNotAvailableByTime="itemsNotAvailableByTime"
      :orderType="order.order_type"
      :startNewOrder="!orderCart || !orderCart.cart || !orderCart.cart.length"
    ></re-order-confirmation>
  </div>
</template>
<script>
import { Button, Cards, Modal } from "@/components";
import { cartManager } from "@/utilities";
import { orderingMixin } from "@/mixins";
import {
  getMenuItemPrice,
  showErrorMessageAlert,
  showMessageConfirmation,
  canMakeOrder,
  checkIfItemAvailbleByOrderType,
  getMenuItemDieatriesIcons,
  generateFromatedAddress,
  completedOrderItemCardFormatter,
  orderItemsFormatter,
  clone,
} from "@/utilities/helper";
import { ORDER_TYPE, OPTION_TYPE } from "@/utilities/enums";
import { ReOrderConfirmation } from "@/views/modals";
import { mapActions } from "vuex";

export default {
  name: "view-order-details-modal",
  mixins: [orderingMixin],
  components: {
    [Button.name]: Button,
    Cards,
    Modal,
    ReOrderConfirmation,
  },
  props: {
    order: Object,
  },
  data() {
    return {
      orderItemsFormatter,
      completedOrderItemCardFormatter,
      getMenuItemDieatriesIcons,
      generateFromatedAddress,
      shown: false,
      showOderTypeModal: false,
      isLoading: false,
      orderCart: null,
      itemsNotAvailable: [],
      itemsWithDiffPrice: [],
      itemsNotAvailableByType: [],
      itemOptionsValuesAvailibility: [],
      itemsNotAvailableForToday: [],
      itemsNotAvailableByTime: [],
      newOrderCart: [],
      orderLocation: null,
    };
  },
  methods: {
    ...mapActions("locationStore", [
      "fetchLocationsByPostCode",
      "fetchTheme",
      "storeSelectedLocation",
    ]),
    ...mapActions("cartStore", ["savePostcode", "clearNewCart"]),
    openModal() {
      this.shown = true;
    },
    closeModal() {
      this.shown = false;
    },
    reOrder() {
      if (this.isLoading) return;
      this.isLoading = true;
      this.newOrderCart = [];
      this.itemsNotAvailable = [];
      this.itemsWithDiffPrice = [];
      this.itemsNotAvailableByType = [];
      this.itemOptionsValuesAvailibility = [];
      this.itemsNotAvailableForToday = [];
      this.itemsNotAvailableByTime = [];

      this.orderLocation = this.order.location;
      this.checkTheLocationAvailibility().then((response) => {
        if (response.status) {
          this.checkTheAvailibilityToMakeOrder().then((continueOrdering) => {
            //=== if the user refuse to continue, close the Modal and exit
            if (!continueOrdering) {
              this.closeModal();
              this.isLoading = false;
              return;
            }

            //**** cleare the cart */
            this.reOrderRequest(this.order.id)
              .then((response) => {
                this.orderCart = response.data.data
                  ? response.data.data[0]
                  : response.data;

                this.checkTheOrderBeforeOrdering(this.orderCart).then(
                  (result) => {
                    //---- show an popup with the order changes
                    if (result) {
                      this.closeModal();
                      this.$refs.reOrderConfirmation.openModal();
                    } else {
                      //---- continue with the re-order : fill the cart with the correct data
                      this.continueReOrdering();
                    }

                    this.isLoading = false;
                  }
                );
              })
              .catch((e) => {
                this.captureException(e);
                this.isLoading = false;
              });
          });
        } else {
          this.isLoading = false;
          showErrorMessageAlert(response.searchErrorText);
        }
      });
    },

    //===== Stap 01 : refresh the location data and check the delivery availability
    checkTheLocationAvailibility() {
      return new Promise((resolve) => {
        if (this.order.order_type != ORDER_TYPE.Delivery.id) {
          this.fetchTheme(this.orderLocation.id).then((location) => {

            if (location) {
              this.orderLocation = location;
              resolve({ status: true });
            } else {
              resolve({
                status: false,
                searchErrorText: this.$t("message.we_dont_deliver_to_area"),
              });
            }
          });
        } else {
          this.fetchLocationsByPostCode(this.order.address.postcode)
            .then((response) => {
              if (response && response.error) {
                //--- display Alert message : Error occured
                resolve({
                  status: false,
                  searchErrorText: this.$t("generic_error.error_occured"),
                });
              } else {
                const locationsInRange = response.data.data.filter(
                  ({ availabe_delivery_postcode }) =>
                    availabe_delivery_postcode === true
                );
                if (locationsInRange.length === 0) {
                  resolve({
                    status: false,
                    searchErrorText: this.$t("message.we_dont_deliver_to_area"),
                  });
                } else {
                  let res = locationsInRange.find(
                    (x) => x.id == this.orderLocation.id
                  );
                  if (res) {
                    this.orderLocation = res;
                    resolve({ status: true });
                  } else {
                    resolve({
                      status: false,
                      searchErrorText: this.$t(
                        "message.we_dont_deliver_to_area"
                      ),
                    });
                  }
                }
              }
            })
            .catch((e) => {
              this.captureException(e);
              resolve({
                status: false,
                searchErrorText: this.$t("generic_error.error_occured"),
              });
            });
        }
      });
    },

    //===== Step 02 : check the availability to make order in the same order location
    checkTheAvailibilityToMakeOrder() {
      return new Promise((resolve) => {
        const orderLocationStatus = canMakeOrder(this.orderLocation);

        let message = this.$t("message.close_now_comeback_later");
        if (this.orderLocation.openingHours.suspended) {
          message = this.$t("message.location_temporary_paused_to", {
            paused_to: this.orderLocation.paused_to,
          });
          showErrorMessageAlert(message);
          resolve(false);
        }
        switch (this.order.order_type) {
          case ORDER_TYPE.Delivery.id:
            if (orderLocationStatus.openingHours.delivery) {
              resolve(true);
            } else if (orderLocationStatus.can_accept_delivery) {
              message = this.$t("message.pre_order_confirmation", {
                location_name: this.orderLocation.name,
              });
              showMessageConfirmation(
                message,
                null,
                null,
                this.$t("button.continue"),
                this.$t("button.cancel")
              ).then((response) => {
                resolve(response);
              });
            } else {
              showErrorMessageAlert(
                this.$t("message.location_not_allowing_delivery")
              );
              resolve(false);
            }

            break;
          case ORDER_TYPE.Collection.id:
            if (orderLocationStatus.openingHours.collection) {
              resolve(true);
            } else if (orderLocationStatus.can_accept_collection) {
              message = this.$t("message.pre_order_confirmation", {
                location_name: this.orderLocation.name,
              });
              showMessageConfirmation(
                message,
                null,
                null,
                this.$t("button.continue"),
                this.$t("button.cancel")
              ).then((response) => {
                resolve(response);
              });
            } else {
              showErrorMessageAlert(
                this.$t("message.location_not_allowing_collection")
              );
              resolve(false);
            }
            break;
          case ORDER_TYPE.Table.id:
            if (
              orderLocationStatus.openingHours.sitIn ||
              orderLocationStatus.can_accept_tableOrdering
            ) {
              resolve(true);
            } else if (!orderLocationStatus.can_accept_tableOrdering) {
              showErrorMessageAlert(
                this.$t("messahe.location_not_allowing_table")
              );
              resolve(false);
            }
            break;
        }
      });
    },

    //===== Step 03 : Validate the Order before Processing and saving
    checkTheOrderBeforeOrdering(ordreDetails) {
      return new Promise((resolve) => {
        this.itemsNotAvailable = [];
        this.itemsNotAvailableByType = [];
        this.itemsNotAvailableForToday = [];
        this.itemsNotAvailableByTime = [];

        if (ordreDetails.not_available?.length) {
          this.itemsNotAvailable = ordreDetails.not_available;
        }

        if (!ordreDetails.cart?.length) {
          resolve({
            showPopUp: true,
            itemsNotAvailable: this.itemsNotAvailable,
            startNewOrder: true,
          });
        }

        if (ordreDetails.not_available_today?.length) {
          this.itemsNotAvailableForToday = ordreDetails.not_available_today;
        }

        if (ordreDetails.not_available_time?.length) {
          this.itemsNotAvailableByTime = ordreDetails.not_available_time;
        }

        for (let orderItem of this.order.orderItems) {
          // get the item for re-order response
          let cartOrderItem = ordreDetails.cart.find(
            (item) => item.id == orderItem.id
          );
          if (!cartOrderItem) continue;

          //--- check if the orderItem still vailable
          if (
            !checkIfItemAvailbleByOrderType(
              this.order.order_type,
              orderItem.menuItem
            )
          ) {
            this.itemsNotAvailableByType.push({
              name: orderItem.name,
              menuItem: orderItem.menuItem,
            });
            continue;
          }

          //#region
          let newOrderMenuItem = clone(orderItem.menuItem);

          if (orderItem.comment) {
            newOrderMenuItem.comment = orderItem.comment.body;
          }

          newOrderMenuItem.quantity = orderItem.quantity;

          newOrderMenuItem = this.checkOrderItemSubItemsAvailibility(
            newOrderMenuItem,
            cartOrderItem
          );
          this.newOrderCart.push(newOrderMenuItem);
          //#endregion
        }

        const showPopUp =
          !!this.itemsNotAvailable.length ||
          !!this.itemsWithDiffPrice.length ||
          !!this.itemsNotAvailableByType.length ||
          !!this.itemOptionsValuesAvailibility.length ||
          !!this.itemsNotAvailableForToday.length ||
          !!this.itemsNotAvailableByTime.length;

        resolve(showPopUp);
      });
    },
    //===== check if the menuItem have any changes in the subItems
    checkOrderItemSubItemsAvailibility(newOrderMenuItem, cartOrderItem) {
      // check diff price
      const menuItemPrice = getMenuItemPrice(
        newOrderMenuItem,
        this.order.order_type
      );
      const orderItemPrice = parseFloat(cartOrderItem.price);
      if (menuItemPrice != orderItemPrice) {
        this.itemsWithDiffPrice.push({
          name: newOrderMenuItem.name,
          menuItemPrice,
          orderItemPrice,
          increased: menuItemPrice > orderItemPrice,
        });
      }

      // check selected options by menuItem
      if (cartOrderItem?.options?.length) {
        let checkOptionsAndValuesAvailibilityResult =
          this.checkOptionsAndValuesAvailibility(
            newOrderMenuItem.options,
            cartOrderItem.options
          );
        if (checkOptionsAndValuesAvailibilityResult.length) {
          this.itemOptionsValuesAvailibility.push({
            name: newOrderMenuItem.name,
            options: checkOptionsAndValuesAvailibilityResult,
          });
        }
      }

      // check selected items by menuItem sections
      if (cartOrderItem.sections?.length && newOrderMenuItem.sections?.length) {
        this.checkSectionsAvailibility(
          newOrderMenuItem.sections,
          cartOrderItem.sections
        );
      }
      return newOrderMenuItem;
    },
    //===== check if the menuItem have any changes in the sections
    checkSectionsAvailibility(menuItemSections, cartOrderItemSections) {
      for (let cartOrderItemSection of cartOrderItemSections) {
        let menuItemSection = menuItemSections.find(
          (section) => section.id == cartOrderItemSection.location_menu_item_id
        );

        if (!menuItemSection) continue;

        if (
          menuItemSection.subProducts?.length &&
          cartOrderItemSection.subProducts?.length
        ) {
          for (let cartSubProduct of cartOrderItemSection.subProducts) {
            // get the menuItem;
            let subProductMenuItem = menuItemSection.subProducts.find(
              (item) => item.id == cartSubProduct.location_menu_item_id
            );
            if (!subProductMenuItem) continue;

            if (
              menuItemSection.type == OPTION_TYPE.radio ||
              menuItemSection.type == OPTION_TYPE.select
            ) {
              menuItemSection.selected = subProductMenuItem.id;
            } else {
              menuItemSection.selected.push(subProductMenuItem.id);
            }
            menuItemSection.selected_items.push({
              id: subProductMenuItem.id,
              name: subProductMenuItem.name,
              price: subProductMenuItem.price,
              quantity: cartSubProduct.quantity,
            });

            this.checkOrderItemSubItemsAvailibility(
              subProductMenuItem,
              cartSubProduct
            );
          }
        }
      }
    },
    //===== check if the menuItem have any changes in the options or values
    checkOptionsAndValuesAvailibility(menuItemOptions, cartOrderItemOptions) {
      let optionsNotExist = [];

      for (let cartOrderItemOption of cartOrderItemOptions) {
        if (cartOrderItemOption.is_deleted) {
          optionsNotExist.push(cartOrderItemOption);
          continue;
        }
        let menuItemOption = menuItemOptions.find(
          (op) => op.id == cartOrderItemOption.menu_option_id
        );

        if (!menuItemOption) continue;

        for (let cartValue of cartOrderItemOption.values) {
          if (cartValue.is_deleted) {
            if (!cartOrderItemOption.missingValues) {
              cartOrderItemOption.missingValues = [];
            }
            cartOrderItemOption.missingValues.push(cartValue);
            optionsNotExist.push(cartOrderItemOption);
            continue;
          }
          // add the selected value to the options
          let menuItemValue = menuItemOption.values.find(
            (v) => v.id === cartValue.menu_option_value_id
          );

          if (!menuItemValue) continue;

          if (
            menuItemOption.type == OPTION_TYPE.radio ||
            menuItemOption.type == OPTION_TYPE.select
          ) {
            menuItemOption.selected = cartValue.menu_option_value_id;
          } else {
            menuItemOption.selected.push(cartValue.menu_option_value_id);
          }

          let menuItemValuePrice = parseFloat(menuItemValue.price);
          let orderItemValuePrice = parseFloat(cartValue.price);

          if (orderItemValuePrice != menuItemValuePrice) {
            this.itemsWithDiffPrice.push({
              name: menuItemValue.name,
              menuItemPrice: menuItemValuePrice,
              orderItemPrice: orderItemValuePrice,
              increased: menuItemValuePrice > orderItemValuePrice,
            });
          }

          menuItemOption.selected_items.push({
            id: menuItemValue.id,
            name: menuItemValue.name,
            price: menuItemValue.price,
            quantity: cartValue.quantity,
          });

          // call recursive function if halue has Options
          if (cartValue.options?.length) {
            optionsNotExist = [
              ...optionsNotExist,
              ...this.checkOptionsAndValuesAvailibility(
                menuItemValue.options,
                cartValue.options
              ),
            ];
          }
        }
      }
      return optionsNotExist;
    },
    continueReOrdering(fromModal = false) {
      //----- if the order type is delivery => request the location based on the order address
      this.setLocation(this.orderLocation);
      this.clearNewCart();
      this.newCart.orderType = this.order.order_type;
      this.newCart.comment = "";
      if (this.newCart.orderType == ORDER_TYPE.Delivery.id) {
        this.savePostcode(this.order.address.postcode);
      }

      this.newCart.order = this.newOrderCart;
      //---- set the delivery_fees
      this.setCartDeliveryFee().then((result) => {
        if (!result) cartManager.setCart(this.newCart, true, false);

        //---- if is coming from confirmation Modal : need to close-it
        if (fromModal) {
          this.$refs.reOrderConfirmation.closeModal();
          this.continueReOrderEventListner();
        }
        this.closeModal();
        this.$nextTick(() => {
          this.$router.push("/menu");
        });
      });
    },
    continueReOrderEventListner() {
      this.$root.$off("CONTINUE_REORDER");
      this.$root.$on("CONTINUE_REORDER", (fromModal) => {
        this.continueReOrdering(fromModal);
      });
    },
    setLocation(location) {
      this.storeSelectedLocation(location);
    },
  },
  created: function () {
    this.continueReOrderEventListner();
  },
};
</script>
